<template>
    <div class="menu_couriers__list_item" :class="classItem" @click.prevent="clickCourier">
        <div class="menu_couriers__list_item_content">
            <div class="menu_couriers__list_item_content_info">
                <div class="menu_couriers__list_item_content_info_circle">
                    <div class="menu_couriers__list_item_content_info_circle_object">
                    </div>
<!--                    <svg>-->
<!--                        <use xlink:href="/icons/base.svg#delivery_circle"></use>-->
<!--                    </svg>-->
                </div>
                <div ref="svgContainer" class="menu_couriers__list_item_content_info_logo">
                </div>
                <div class="menu_couriers__list_item_content_info">
                    <div class="menu_couriers__list_item_content_info_block">
                        <div class="menu_couriers__list_item_content_info_block_courier">
                            <div class="menu_couriers__list_item_content_info_block_courier_number">
                                {{ courierCode }}
                            </div>
                            <div class="menu_couriers__list_item_content_info_block_courier_summ">
                                {{ courierSum }}
                            </div>
                            <div class="menu_couriers__list_item_content_info_block_courier_date">
                                {{ courierDate }}
                            </div>
                        </div>
                    </div>
                    <div class="menu_couriers__list_item_content_info_state_new" v-if="isStateCourier">
                        <div class="menu_couriers__list_item_content_info_state_new_text">
                            {{ __t(stateCourier) }}
                        </div>
                    </div>
                    <div class="menu_couriers__list_item_content_info_state_time" v-if="isCourierInProgress">
                            <span class="menu_couriers__list_item_content_info_state_time_text"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import insertSvg from "../../../mixins/insertSvg";
import formatNumber from "../../../mixins/formatNumber";
import {createHelpers} from "vuex-map-fields";
import {screenSize} from "../../../mixins/screenSize";
import getObjectPathProperty from "../../../mixins/getObjectPathProperty";

const {mapFields: mUser} = createHelpers({
    getterType: 'user/getUserField',
    mutationType: 'user/updateUserField',
})
const {mapFields: mCouriers} = createHelpers({
    getterType: 'couriers/getCouriersField',
    mutationType: 'couriers/updateCouriersField',
})

export default {
    name: "menu_couriers_item",
    props: {
        courierItem: {
            type: Object,
            required: true,
        },
    },
    emits: [],
    components: {},
    mixins: [insertSvg, formatNumber, screenSize],
    mounted() {
        if (this.getObjectPathProperty(this.courierItem, 'aggregator.icon')) {
            this.insertSvg(this.courierItem.aggregator.icon);
        }
    },
    methods: {
        clickCourier() {
            if(this.isMobileScreen){
                this.$store.dispatch('couriers/STATE_SELECT_COURIER_ITEM', true);
            }
            this.$store.dispatch('couriers/CLICK_ITEM_MENU_COURIERS', this.courierItem);
        }
    },
    computed: {
        ...mUser([
            'user',
        ]),
        ...mCouriers([
            'activeCourierOrder',
        ]),
        classItem() {
            let classCourierItem = {
                'active': false,
                'error': false,
            }
            if(this.courierItem.id && this.activeCourierOrder && this.activeCourierOrder.id){
                classCourierItem.active = this.courierItem.id === this.activeCourierOrder.id;
            }
            // if (this.courierItem.pos_send_status && this.courierItem.pos_send_status === 'error') {
            //     classCourierItem.error = true;
            // }
            return classCourierItem;
        },
        courierCode() {
            if (this.courierItem.order_uniq) {
                return this.courierItem.order_uniq;
            }
            return 'No id courier'
        },
        courierSum() {
            if (this.user.currency_suffix && this.user.locale) {
                return this.toCurrency(this.courierItem.price, this.user.currency_suffix, 'uk-UA', 2);
            }
            return this.toCurrency(this.courierItem.price, '');
        },
        courierDate() {
            if(this.courierItem.order && this.courierItem.order.added){
                return this.courierItem.order.added;
            }
            return '';
        },
        isCourierInProgress() {
            return this.courierItem.typeCourier === 'inProgress';
        },
        isStateCourier() {
            return this.courierItem.typeCourier === 'new'
        },
        dateCourier() {
            if (this.courierItem && this.courierItem.added) {
                return this.courierItem.added;
            }
            return '';
        },
        stateCourier(){
            return 'O.NEW';
        }
    },
}
</script>
